/**
 * @generated SignedSource<<a13a514f26134241439cf476d06bd945>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pantoneLibraryDialogImportDefaultPaletteMutation$variables = {
  id: string;
};
export type pantoneLibraryDialogImportDefaultPaletteMutation$data = {
  readonly importDefaultPalette: string;
};
export type pantoneLibraryDialogImportDefaultPaletteMutation = {
  response: pantoneLibraryDialogImportDefaultPaletteMutation$data;
  variables: pantoneLibraryDialogImportDefaultPaletteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "importDefaultPalette",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b25bc2ab49e9ee312537faaefb475ea3",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryDialogImportDefaultPaletteMutation",
    "operationKind": "mutation",
    "text": "mutation pantoneLibraryDialogImportDefaultPaletteMutation(\n  $id: ID!\n) {\n  importDefaultPalette(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "64b30b204901b00069fa6d8bcc12c40f";

export default node;
